/* B&M – Bandes croisées (sections/bm-crossband-science.liquid).
   - L'animation (CSS) ne tourne que lorsque la carte est à l'écran : on ajoute .is-visible à la carte,
     on la retire quand elle sort (l'animation se met en pause). Sans IntersectionObserver : toujours active.
   - Vidéo de fond facultative : téléchargée seulement quand la carte arrive à l'écran (src posée depuis data-src),
     lue sans le son en boucle, mise en pause hors de l'écran. « Réduire les animations » : jamais chargée.
     Erreur ou lecture automatique refusée : la vidéo est masquée, l'image reste affichée. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function fail(video) {
    video.classList.remove('is-playing');
    video.classList.add('is-failed');
  }

  function playVideo(video) {
    if (!video || reduceMotion.matches || video.classList.contains('is-failed')) return;
    if (!video.getAttribute('src')) {
      video.addEventListener('error', function () { fail(video); }, { once: true });
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      video.muted = true;
      video.src = video.getAttribute('data-src');
    }
    var attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(function (error) {
        if (error && error.name === 'NotAllowedError') fail(video);
      });
    }
  }

  function setVisible(card, visible) {
    card.classList.toggle('is-visible', visible);
    var video = card.querySelector('[data-bmx-video]');
    if (!video) return;
    if (visible) {
      playVideo(video);
    } else if (video.getAttribute('src')) {
      video.pause();
    }
  }

  function init(root) {
    var cards = (root || document).querySelectorAll('[data-bmx-card]:not([data-bmx-ready])');
    cards.forEach(function (card) {
      card.setAttribute('data-bmx-ready', '');
      if (!('IntersectionObserver' in window)) {
        setVisible(card, true);
        return;
      }
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVisible(card, entry.isIntersecting);
          });
        },
        { threshold: 0.25 }
      ).observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
